import { ReactNode } from 'react';
import { TabId } from 'helpers/kpiBuilder/types';
import { BuilderIssues } from './BuilderIssues';

interface BuilderTabContentProps {
  tab: TabId;
  builderMode: boolean;
  children: ReactNode;
}

// Builder warnings appear as banners at the top of the tab they belong to.
export const BuilderTabContent = ({ tab, builderMode, children }: BuilderTabContentProps) => (
  <>
    {builderMode && <BuilderIssues tab={tab} />}
    {children}
  </>
);
